import { useEffect, useState } from 'react';
import { resolveVariant, trackExposure, TEST } from '../../utils/experimentAssignment';
import Landing from '../Landing/Landing';
import BaseLandingV2 from '../CustomLandings/BaseLandingV2/BaseLandingV2';

const FLAG_KEY = 'landing-v2';

// Share of /benefithub visitors entering the experiment at all. The rest see the
// control page and are not counted. Keep this in sync with the flag's rollout in
// PostHog, since a visitor with cached flags is assigned by the flag instead.
const ENROLLED_SHARE = 0.50;

// Share of *enrolled* visitors who see BaseLandingV2.
const TEST_SHARE = 0.50;

export default function BenefitHubExperimentEntry() {
    // Resolved once, synchronously, so the correct page paints on the first
    // render — no gate and no swap.
    const [assignment] = useState(() =>
        resolveVariant({ flagKey: FLAG_KEY, enrolledShare: ENROLLED_SHARE, testShare: TEST_SHARE })
    );

    useEffect(() => {
        trackExposure(FLAG_KEY, assignment.variant);
    }, [assignment.variant]);

    if (assignment.variant === TEST) {
        return <BaseLandingV2 />;
    }

    return <Landing />;
}
